export const secondsToMinutesAndSeconds = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  const minAndSeconds = `${minutes}:${formattedSeconds} min`;

  return minAndSeconds;
};
